<script setup>
import {ref} from 'vue'
import {useLightboxStore} from '@/stores/lightbox'
import {useItemDataStore} from '@/stores/itemData'
import {useViewStore} from '@/stores/view'
import {useAppStore} from '@/stores/appStore'

const props = defineProps({
    item: Object,
    value: Number,
    viewId: String
})

// Dynamic Pinia View Store & Pinia Stores
const viewStore = useViewStore(props.viewId)
const lightboxStore = useLightboxStore()
const itemDataStore = useItemDataStore()
const appStore = useAppStore()

const fileName = ref('')
const isImage = ref(false)

// Async initialization logic
const init = async () => {
    try {
        const obj = await itemDataStore.get({
            tableName: 'files',
            id: props.value
        })

        if (!obj) return

        fileName.value = obj.fileName

        isImage.value = Boolean(
            obj.mimetype && obj.mimetype.indexOf('image') === 0
        )

        if (isImage.value) {
            lightboxStore.add({
                id: props.value,
                title: obj.fileName,
                src: appStore.fileSrc(obj.fileName),
                onShow: () => {
                    viewStore.onClick(props.item.id)
                }
            })
        }
    } catch (error) {
        console.error('Failed to load file item data:', error)
    }
}

init()

const onClick = async () => {
    if (isImage.value) {
        lightboxStore.show(props.value)
    }
}
</script>

<template>
    <a :title="fileName" href="#" @click.prevent="onClick">{{ fileName }}</a>
</template>